import { ActivityPage } from '@repo/ccc-main-app-lib/src/pages/ActivityPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/activity')({
  component: UserActivityPage,
})

function UserActivityPage() {
  const { userId } = Route.useParams()

  return <ActivityPage userId={userId} />
}
